"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get sanitize () {
        return sanitize;
    },
    get sanitizeAndEscapeDots () {
        return sanitizeAndEscapeDots;
    },
    get unsanitize () {
        return unsanitize;
    }
});
function sanitize(v) {
    if (typeof v !== 'string') return v;
    return v == null ? void 0 : v.replace(/([^\\]|^)(\?+)/g, (_, m1, m2)=>{
        return `${m1}${m2.split('?').join('\\?')}`;
    });
}
function unsanitize(v) {
    if (typeof v !== 'string') return v;
    return v == null ? void 0 : v.replace(/\\[?]/g, '?');
}
function sanitizeAndEscapeDots(alias, knex) {
    var _knex_clientType;
    const sanitizedAlias = sanitize(alias);
    // if alias does not contain any dot then return as it is
    if (!knex || !sanitizedAlias.includes('.')) return sanitizedAlias;
    // if alias contains dot then return knex.raw with escaped dot
    switch(knex == null ? void 0 : (_knex_clientType = knex.clientType) == null ? void 0 : _knex_clientType.call(knex)){
        case 'mysql':
        case 'mysql2':
            return knex.raw(knex.raw('??', sanitizedAlias).toQuery().replace(/`\.`/g, '.'));
        case 'pg':
            return knex.raw(knex.raw('??', sanitizedAlias).toQuery().replace(/"\."/g, '.'));
        default:
            return sanitizedAlias;
    }
}
